export default function Splash() {
  return (
    <div className="splash">
      <div className="spinner" aria-label="加载中" />
    </div>
  );
}